import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const tenantAuthConfigMenuRegistry = {
    core_tenantAuthConfig: {
        label: "Tenant Auth Configs",
        link: PAGE_URL.TENANT_AUTH_CONFIG_PAGE,
        key: PAGE_URL.TENANT_AUTH_CONFIG_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default tenantAuthConfigMenuRegistry;

